import type { AccountsConfig } from './type';

export const accounts: AccountsConfig = {
    sendAccountNumberWithPut: true,
    isJuniorAliasChangeAllowed: true,
    isNativeAliasChangeAllowed: true,
    accountDetailCopyActionAvailableForType: ['CURRENT', 'SAVING', 'LOAN'],
};
